import {ReactElement} from 'react'

// BookIcon's open book, cropped to the glyph so it fills the 16 px box like
// the 24-grid header icons; the 0.87 stroke renders at their 1.7 weight.
export const DopamineAssistantGuideIcon = (): ReactElement => (
  <svg
    aria-hidden="true"
    fill="none"
    height="16"
    viewBox="1.9 1.9 12.2 12.2"
    width="16"
  >
    <path
      d="M12.8333 3.83317C12.8333 3.46498 12.5349 3.1665 12.1667 3.1665H9.33333C8.59695 3.1665 8 3.76346 8 4.49984V12.8332L8.55229 12.2809C9.05238 11.7808 9.73066 11.4998 10.4379 11.4998H12.1667C12.5349 11.4998 12.8333 11.2014 12.8333 10.8332V3.83317Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.87"
    />
    <path
      d="M3.16663 3.83317C3.16663 3.46498 3.4651 3.1665 3.83329 3.1665H6.66663C7.40301 3.1665 7.99996 3.76346 7.99996 4.49984V12.8332L7.44767 12.2809C6.94758 11.7808 6.2693 11.4998 5.56206 11.4998H3.83329C3.4651 11.4998 3.16663 11.2014 3.16663 10.8332V3.83317Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.87"
    />
  </svg>
)
